export default {
    CREATE: 'create',
    EDIT: 'edit',
    CANCEL: 'cancel',
};
